module.exports = __webpack_public_path__ + "static/media/model-guide.6b67126a.png";